<div class="row-col inbox-card" [ngClass]="{'detail-view' : showDetailView}">
  <h3>{{ 'MENU.MY_TASKS' | translate }}</h3>

  <gp-back-link
    [linkText]="'INBOX.view_all_tasks'"
    (linkClick)="backToList()">
  </gp-back-link>

  <div class="p-t-md p-t-xs">
    <ul class="nav nav-tabs">

      <li class="nav-item inline">
        <a class="nav-link block"
           test-id="workflows-tasks"
           [routerLink]="['/inbox/tasks']"
           [queryParams]="{status: 'IN_PROGRESS'}"
           [routerLinkActive]="'active'"
           [routerLinkActiveOptions]="isActiveMatchOptions">
          {{ 'WORKFLOWS.received' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link block"
           test-id="workflows-requests"
           [routerLink]="['/inbox/requests']"
           [routerLinkActive]="'active'"
           [routerLinkActiveOptions]="isActiveMatchOptions">
          {{ 'WORKFLOWS.created' | translate }}
        </a>
      </li>
    </ul>
  </div>
  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
